import styled from 'styled-components'
import theme from '../utils/theme'


export const Label = styled.span`
  font-size: 14px;
  line-height: 16px;
`

export const SubLabel = styled.span`
  font-size: 10px;
`

export const Error = styled.span`
  color: ${ theme.palette.red };
  margin-top: 4px;
`
export const Success = styled.span`
  color: ${ theme.palette.green };
  margin-top: 4px;
`
export const Comment = styled.span`
  color: ${ theme.palette.dark_blue };
  font-size: 10px;
  line-height: 12px;
`

export const Description = styled.span`
  font-size: 10px;
  font-weight: normal;
  margin-top: 8px;
`

export const Sector = styled.span`
  color: ${ theme.palette.dark_blue };
  font-size: 18px;
  font-weight: bold;
`
